/**
 * 时间格式化
 * @param value
 * @param fmt
 * @returns {*}
 */
export function formatDate(value, fmt) {
    var regPos = /^\d+(\.\d+)?$/
    if (regPos.test(value)) {
        // 如果是数字
        var getDate = new Date(value)
        var o = {
            'M+': getDate.getMonth() + 1,
            'd+': getDate.getDate(),
            'h+': getDate.getHours(),
            'm+': getDate.getMinutes(),
            's+': getDate.getSeconds(),
            'q+': Math.floor((getDate.getMonth() + 3) / 3),
            'S': getDate.getMilliseconds()
        }
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
        }
        return fmt
    } else {
        // TODO
        value = value.trim()
        return value.substr(0, fmt.length)
    }
}

/*
 * formatMoney(value,type)
 * 功能：金额按千位逗号分割
 * 参数：value，需要格式化的金额数值.
 * 参数：type,判断格式化后的金额是否需要小数位.
 * 返回：返回格式化后的数值字符串.
 */
export function formatMoney(value, type) {
    if (/[^0-9\.]/.test(value)) {
        return "0";
    }
    if (value == null || value == "") {
        return "0";
    }
    value = value.toString().replace(/^(\d*)$/, "$1.");
    value = (value + "00").replace(/(\d*\.\d\d)\d*/, "$1");
    value = value.replace(".", ",");
    var re = /(\d)(\d{3},)/;
    while (re.test(value))
        value = value.replace(re, "$1,$2");
    value = value.replace(/,(\d\d)$/, ".$1");
    if (type == 0) { // 不带小数位(默认是有小数位)
        var a = value.split(".");
        if (a[1] == "00") {
            value = a[0];
        }
    }
    return value;
}